import { render } from "./ClientTopNav.vue?vue&type=template&id=549e0b1f&scoped=true"
import script from "./ClientTopNav.vue?vue&type=script&lang=js"
export * from "./ClientTopNav.vue?vue&type=script&lang=js"

import "./ClientTopNav.vue?vue&type=style&index=0&id=549e0b1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549e0b1f"]])

export default __exports__